import React, { useEffect, useState } from "react";
import { Button, Segmented, Space } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import GenericCard from "components/UI/GenericCard/GenericCard";
import { apiGetAdminFillQuality } from "api/apiAdmin";
import FillQualityTable from "components/FillQuality/FillQualityTable";

// Real-trades analysis, first part: AutoTrader fill quality across all users
const AdminFillQuality = () => {
  const [days, setDays] = useState(30);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    try {
      setLoading(true);
      setData(await apiGetAdminFillQuality(days));
    } catch (error) {
      console.error("Error fetching fill quality:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [days]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <GenericCard
      title="Fill Quality"
      className="table-card"
      tooltipText="Filled AutoTrader orders of all users, by user / type / side / algo / urgency"
    >
      <Space className="flex justify-between mb-4">
        <Segmented
          value={days}
          onChange={setDays}
          options={[
            { label: "7 days", value: 7 },
            { label: "30 days", value: 30 },
            { label: "90 days", value: 90 },
            { label: "1 year", value: 365 },
          ]}
        />
        <Button type="primary" icon={<ReloadOutlined />} onClick={load} loading={loading}>
          Refresh Data
        </Button>
      </Space>
      {data?.total && (
        <div className="mb-4">
          {data.total.orders} orders | avg vs mid{" "}
          {data.total.vsMid === null ? "-" : `${data.total.vsMid.toFixed(2)}%`} | avg vs
          advised{" "}
          {data.total.vsAdvised === null ? "-" : `${data.total.vsAdvised.toFixed(2)}%`}
        </div>
      )}
      <FillQualityTable data={data} showOwner />
    </GenericCard>
  );
};

export default AdminFillQuality;
